import { ActionReducer, MetaReducer } from '@ngrx/store';
import { AppState } from '../app.reducer'

export function localStorageSyncReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    const nextState = reducer(state, action);

    // Puedes ajustar qué slices guardar (ej: auth, user, etc.)
    const stateToSave = {
      auth: nextState['auth'],
      project: nextState['project'],
    };

    localStorage.setItem('appState', btoa(JSON.stringify(stateToSave)));

    return nextState;
  };
}

export const metaReducers: MetaReducer<AppState>[] = [localStorageSyncReducer];